import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pb2000',
    ecrans: ['00-2'],
    params: ['id']
});
